// set version of localSession/sessionStorage to be sure data is not deprecated
const STORAGE_VERSION = 'v1.5';

export const removeDeprecatedStorageData = (): void => {
  Object.keys(sessionStorage).forEach((key: string) => {
    const isAppKey = key.split('-')[0];
    const version = key.split('-')[1];
    if (isAppKey === 'cloud' && version !== STORAGE_VERSION) {
      sessionStorage.removeItem(key);
    }
  });
  Object.keys(localStorage).forEach((key: string) => {
    const isAppKey = key.split('-')[0];
    const version = key.split('-')[1];
    if (isAppKey === 'cloud' && version !== STORAGE_VERSION) {
      localStorage.removeItem(key);
    }
  });
};

export const getLocalStorageKey = (key: string): string => `cloud-${STORAGE_VERSION}-${key}`;
export const getSessionStorageKey = (key: string): string => `cloud-${STORAGE_VERSION}-${key}`;
